export default __webpack_public_path__ + "static/media/user2.20e7a5db.jpg";